// extracted by mini-css-extract-plugin
module.exports = {"Alpha":"Alpha__3jSzA"};